module.exports = __webpack_public_path__ + "static/media/zewzealand02.bf93cb0f.jpg";